import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ReactComponent as CloseCall } from "../../Assets/icons/calls/closeCall.svg";
import { ReactComponent as NoAvatar } from "../../Assets/icons/calls/noAvatar.svg";
import { colors } from "../../Assets/styles/colors";
import { displayName } from "../../Helpers/chatHelper/NameHelper";
import { useAuthService } from "../../Context/AuthContext";
import { useIsSpeaking, useParticipantTile } from "@livekit/components-react";
import { useTranslate } from '@tolgee/react';

const ScreenShareParticipant = ({ screenShareParticipant, callInfo, handleSelectScreenShareParticipant, isSelected }) => {

    const { user } = useAuthService();
    const { t } = useTranslate();

    const divRef = useRef(null);
    const videoRef = useRef(null);

    const [vTrack, setVTrack] = useState(null);
    const [participantInfoFromCall, setParticipantInfoFromCall] = useState(null);

    const participant = screenShareParticipant.participant
    let tracks = participant.getTrackPublications();

    const getParticipantInfoFromCall = () => {
        let info;
        let foundInOthers = callInfo.other_participants.find(
            (p) => p.id == participant.identity
        );

        if (participant.identity == callInfo.created_by.id) {
            info = callInfo.created_by;
        } else if (foundInOthers) {
            info = foundInOthers;
        } else {
            info = user;
        }

        if (info) {
            setParticipantInfoFromCall(info);
        }
    };

    const getPresenterLabel = () => {
        const name = participantInfoFromCall?.name || 'Presenter';
        if (participant.isLocal) {
            return `${name} (${t('share_screen.you_presenting')})`;
        }
        return `${name} (${t('share_screen.presenting')})`;
    };



    useEffect(() => {
        let videoTrack = tracks.find((track) => track.source === "screen_share" && track.track != null);
        if (videoTrack && videoTrack?.track) {
            setVTrack(videoTrack);
            videoTrack.track.attach(videoRef.current);
        } else {
            setVTrack(null);
        }
    }, [tracks]);

    useEffect(() => {
        getParticipantInfoFromCall();
    }, [participant]);



    return (
        <ConnectingContainer ref={divRef} onClick={() => handleSelectScreenShareParticipant(screenShareParticipant)} isSelected={isSelected}>
            <VideoContainer>
                <video ref={videoRef} autoPlay muted playsInline />
                {participantInfoFromCall && (
                    <PresenterName>
                        {getPresenterLabel()}
                    </PresenterName>
                )}
            </VideoContainer>
        </ConnectingContainer>
    );
};

export default ScreenShareParticipant;
const ConnectingContainer = styled.div`
  display: flex;
  flex:0 0 calc(25% - 10px);
  min-height:150px;
  min-width:250px;
  max-height:150px;
  border: ${({ isSelected, theme }) => 
    isSelected 
        ? `2px solid ${theme.primaryButton.borderColor}`
        : `1px solid ${theme.sidebar.borderColor}`
    };

  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.callComponent.participantComponentBackground};
  overflow: hidden;
  border-radius: 4px;
  cursor:pointer;
  transition: border 0.2s ease;
  &:hover {
    border-color: ${({ theme }) => theme.primaryButton.borderColor};
  }
`;

const VideoContainer = styled.div`
 width: 100%; 
  height: 100%; 
  position: relative;
  overflow: hidden; 
  display: flex; 
  align-items: center;
  justify-content: center;
video {
 width: 100%;
  height: 100%;
  object-fit: cover; 
  object-position: center;
  }
`
const PresenterName = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
`;